import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import { withRouter } from "react-router"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import DataTableOrientation from "./DataTableOrientation"
import AddOrientation from "./AddOrientation"
const Orientation = props => {
  const [section, setSection] = useState(2)

  useEffect(async () => {

  }, [])
  const back = () => {
    setSection(1)
  }
  const renderBlock = section => {
    if (section === 1) {
      return <DataTableOrientation />
    } else if (section === 2) {
      return <AddOrientation setSection={setSection} back={back} />
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.t("Matière Orientation")} | Cresus </title>
        </MetaTags>
        <Container fluid>
          <div>
            <Nav tabs>
              {/*<NavItem>*/}
              {/*  <NavLink*/}
              {/*    style={{ cursor: "pointer" }}*/}
              {/*    className={classnames({*/}
              {/*      active: section === 1,*/}
              {/*    })}*/}
              {/*    onClick={() => {*/}
              {/*      setSection(1)*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {props.t("Orientation")}*/}
              {/*  </NavLink>*/}
              {/*</NavItem>*/}
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: section === 2,
                  })}
                  onClick={() => {
                    setSection(2)
                  }}
                >{props.t("Orientation")}
                </NavLink>
              </NavItem>
            </Nav>
            <Card>
              <CardBody>{renderBlock(section)}</CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(withTranslation()(Orientation))
Orientation.propTypes = {
  t: PropTypes.any,
}
